module.exports = __webpack_public_path__ + "assets/shoot-btn-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/shoot-btn-icon.svg
// module id = 809
// module chunks = 0